import React from "react";
import { useSlc, RootState } from "app/store";
import { WrapperUserWishesDone } from "app/wrappers";
import RedirectTo from "components/RedirectTo/RedirectTo";

export const UserWishesDone = () => {
  const isAuth = useSlc((state: RootState) => state.user.isAuth);

  if (isAuth) return <WrapperUserWishesDone />;
  return <RedirectTo path="/sign-in" />;
};
